module.exports = __webpack_public_path__ + "static/img/108001.38f4a6cf.png";